import { defaultApiErrorHandle } from '@/helpers/errorHandler';
import httpClient, { apiSdk } from '@/httpClient';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Modal, Upload } from 'antd';
import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  maxFileSize?: number;
  onChange?: (value: string | string[] | null | undefined) => void;
  value?: string | string[] | null | undefined;
  disabled?: boolean;
}

export default function SingleVideoUpload({ maxFileSize = 10, onChange, value, disabled }: Props): ReactElement {
  const { t } = useTranslation();
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [fileList, updateFileList] = useState<any[]>([]);

  function beforeUpload(fileSize: number): boolean {
    if (fileSize / 1024 / 1024 > maxFileSize) {
      Modal.error({
        title: t('singleUpload_Error'),
        content: t('singleUpload_ErrorMaxFileSize', { maxFileSize: maxFileSize }),
      });
      return false;
    }
    return true;
  }
  function handleRemove() {
    if (onChange) {
      onChange(undefined);
    }
  }

  React.useEffect(() => {
    if (value) {
      if (Array.isArray(value)) {
        updateFileList(
          value.map((x, i) => {
            return { uid: (i + 1).toString(), status: 'done', url: x, name: x };
          }),
        );
      } else {
        updateFileList([
          {
            uid: '1',
            status: 'done',
            url: `https://vimeo.com/${value}`,
            name: `https://vimeo.com/${value}`,
          },
        ]);
      }
    } else {
      updateFileList([]);
    }
  }, [value]);
  const manualUpload = async options => {
    setLoadingUpload(true);
    var formData = new FormData();
    formData.append('file', options.file);

    httpClient
      .post('/liane-advertising/upload-video', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(res => {
        if (res.data.success) {
          if (onChange) {
            onChange(res.data.videoId || '');
          }
        }
      })
      .catch(defaultApiErrorHandle)
      .finally(() => {
        setLoadingUpload(false);
      });
  };
  const uploadButton = React.useMemo(() => {
    return (
      <Button type="default">
        <div className="ant-upload-text">{t('Upload video')}</div>
      </Button>
    );
  }, []);
  return (
    <Upload
      disabled={disabled}
      listType="text"
      multiple={false}
      accept="video/mp4,video/x-m4v,video/*"
      fileList={fileList}
      beforeUpload={file => beforeUpload(file.size)}
      customRequest={manualUpload}
      onRemove={file => handleRemove()}
    >
      {loadingUpload ? <LoadingOutlined /> : fileList?.length ? null : uploadButton}
    </Upload>
  );
}
